import request from '@/utils/request';

/**
 * 首页轮播图地址
 * @returns {Promise<*>}
 */
export async function getBannerList() {
  return request('/api/zeyin_school/app/banner/list');
}

/**
 * 课程分类
 * @param params
 *  isShow 不传返回全部分类，传1返回首页展示分类
 * @returns {Promise<*>}
 */
export async function getCategoryList(params) {
  return request('/api/zeyin_school/app/course/category/list', { params });
}


/**
 * 首页课程展示
 * @param params
 * @returns {Promise<*>}
 */
export async function getHomeCourse(params) {
  return request('/api/zeyin_school/app/course/home', { params });
}



/**
 * 课程列表
 * @param params
 * @returns {Promise<*>}
 */
export async function getCourseList(params) {
  return request('/api/zeyin_school/app/course/list', { params });
}

/**
 * 栏目列表
 * @param params
 * @returns {Promise<*>}
 */
export async function getColumnList(params) {
  return request('/api/zeyin_school/app/column/list', { params });
}


/**
 * 热门搜索
 * @param params
 * @returns {Promise<*>}
 */
export async function getHotSearch(params) {
  return request('/api/zeyin_school/app/hotSearch/list', { params });
}



/**
 * 门店列表
 * @param params
 * @returns {Promise<*>}
 */
export async function getStoreList(params) {
  return request('/api/zeyin_school/app/shop/list', { params });
}


/**
 * 区域列表
 * @param params
 * @returns {Promise<*>}
 */
export async function getAreaList(params) {
  return request('/api/zeyin_school/app/area/list', { params });
}


/**
 * 获取弹屏
 * @param params
 * @returns {Promise<*>}
 */
export async function getAdPush(params) {
  return request('/api/zeyin_school/app/push/getPush', { params });
}

/**
 * 获取弹屏
 * @param params
 * @returns {Promise<*>}
 */
export async function clickAdPush(params) {
  return request('/api/zeyin_school/app/push/clickPush', { params });
}
